import { render } from "./BreedingValuesView.vue?vue&type=template&id=e1343042&scoped=true&ts=true"
import script from "./BreedingValuesView.vue?vue&type=script&lang=ts"
export * from "./BreedingValuesView.vue?vue&type=script&lang=ts"

import "./BreedingValuesView.vue?vue&type=style&index=0&id=e1343042&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1343042"]])

export default __exports__